import { Component,OnInit } from '@angular/core';
import { UsuariosPersonalService} from '../../../services/usuarios-personal.service';
import { UnidadesService} from '../../../services/unidades.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operator/map';    

@Component({
    selector: 'cambio-unidad',
	templateUrl : './cambio-unidad.component.html'
})

export class CambioDeUnidadComponent  implements OnInit{
    //Declaracion de los servicios que se ocuparan.
    constructor(
        private personalService:UsuariosPersonalService,
        private unidadesService:UnidadesService,
    ){}
    //Declaracion de  variables
    listaDeUnidades:Observable<any>;
    listaOperadores:Observable<any>;
    listaDeOperadoresOcupados:Observable<any>;
    operador1:any;
    operador2:any;
    ngOnInit(){
        this.obtenerOperadores()
    }
    obtenerOperadores(){
        //Primero se obtienen todas las uniddes
        this.listaDeOperadoresOcupados = this.unidadesService.obtenerUnidades().snapshotChanges().map(unidadesTodas=>{
            let arregloDeKeys= []
             unidadesTodas.forEach(unidad => {
                 let $key= unidad.payload.doc.id
               let datos = unidad.payload.doc.data()
               //Se verifica que la unidad  tenga un operador si lo tiene se regresa la infromacion del operador y de la unidad que lo contiene
               if(datos.operador != " ")
                 arregloDeKeys.push({'$key':datos.operador, 'unidad':$key})
             });
             return arregloDeKeys
         })
        
    }
    cambioSinReporte(op1, op2){
        //Este metodo recibe 2 parametros la $key  y unidad de ambos operadores
        //Se separa la $key del id de la unidad '$keyOperador idUnidad'
        let operador1= op1.split(" ")[0]; 
        let unidad1=op1.split(" ")[1];
        let operador2= op2.split(" ")[0];
        let unidad2=op2.split(" ")[1];
        //Se verifica que los operadores seleccionados no sean los mismos en caso de serlo manda una alerta
        if(operador1 != operador2){
            //Realiza la consulta a un servicio que recibe ambos operadores y ambas unidades para poder  cambiarlos entre si.
            this.unidadesService.cambioDeUnidadSinReporte(operador1, unidad1, operador2, unidad2).then(res=>{
                //Una ves completo el proceso limpia el formulario y manda un mensaje
                alert('Unidades reasignadas con exito')
                this.operador1=undefined;
                this.operador2=undefined;
            })
        }else{
            alert('Los operadores no pueden ser iguales')
        }      

    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/cambio-unidad/cambio-unidad.component.ts